import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PeriodeKurbanCard } from './PeriodeKurbanCard';
import { PeriodeKurbanEditDialog } from './periode-kurban-edit-dialog/PeriodeKurbanEditDialog';
import { PeriodeKurbanUIProvider } from './PeriodeKurbanUIContext';
import { PrivateRoute } from "../../../../../PrivateRoute";
import { RoleChecker } from '../../../../../RoleChecker';


export function PeriodeKurbanPage({ history }) {

    const periodeKurbanUIEvents = {
        newPeriodeKurbanButtonClick: () => {
            history.push('/kurban/periode-kurban/new');
        },
        openEditPeriodeKurbanPage: (id) => {
            history.push(`/kurban/periode-kurban/${id}/edit`);
        },
    };

    return (
        <PeriodeKurbanUIProvider periodeKurbanUIEvents={periodeKurbanUIEvents}>

            <Route path="/kurban/periode-kurban/new">
                {({ history, match }) => (
                    <PeriodeKurbanEditDialog
                        show={match != null}
                        onHide={() => {
                            history.push('/kurban/periode-kurban/');
                        }}
                    />
                )}
            </Route>

            <Route path="/kurban/periode-kurban/:id/edit">
                {({ history, match }) => (
                    <PeriodeKurbanEditDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => {
                            history.push('/kurban/periode-kurban/');
                        }}
                    />
                )}
            </Route>



            <PeriodeKurbanCard />
        </PeriodeKurbanUIProvider>
    );
}
